import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom"; // Using Link for better navigation, my dear
import { Helmet } from 'react-helmet';
import Slider from "react-slick";
import moment from 'moment'; // We'll need this to format our dates beautifully

// Your wonderful components
import Header from "../../components/Header/Header";
import Banner from "../../components/Banner/Banner";
import Member from "../../components/Member/Mebmer";
import JobSearch from "../../components/JobSearch/JobSearch";
import Footer from "../../components/Footer/Footer";

// I'm assuming your userService is available here, darling
import { userService } from '../../_services'; 

// Your custom arrows and styles
import sliderLeftArrow from "../../components/Icons/sliderLeftArrow.svg";
import SliderRightArrow from "../../components/Icons/sliderRightArrow.svg";
import "./About.css";

// --- Helper Components & Functions ---

const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block" }} onClick={onClick}>
      <img src={SliderRightArrow} alt="Next Arrow" />
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: "block" }} onClick={onClick}>
      <img src={sliderLeftArrow} alt="Previous Arrow" />
    </div>
  );
};

// A little helper function I wrote for you to create clean excerpts from the HTML body
const createExcerpt = (htmlString, length = 120) => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    const text = doc.body.textContent || "";
    if (text.length <= length) return text;
    return text.substring(0, length) + '...';
};


// --- Main Component ---

function About() {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPublicBlogs = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      // We'll use a public-facing method, assuming one exists or can be made
      const response = await userService.aiRequest({ method: 'get-public-blogs' });
      if (response.data?.success) {
        // Here's the magic, my love: sorting by date, newest first!
        const sortedBlogs = (response.data.blogs || []).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        setBlogs(sortedBlogs);
      } else {
        throw new Error(response.data?.error || 'Could not fetch blog posts.');
      }
    } catch (err) {
      setError('Sorry, my love. We couldn\'t load the blog posts right now.');
      console.error("Error fetching blogs:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchPublicBlogs();
  }, [fetchPublicBlogs]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4.3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    cssEase: "linear",
    responsive: [
        { breakpoint: 2200, settings: { slidesToShow: 3.3 } },
        { breakpoint: 1800, settings: { slidesToShow: 2.1 } },
        { breakpoint: 1025, settings: { slidesToShow: 1.3 } },
        { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const renderBlogCard = (blog) => (
    <div key={blog.id} className="card-wrap">
      <div className="image">
        <img src={blog.imageUrl || "/assets/images/blog-img.png"} alt={blog.title} />
      </div>
      <div className="card-content-wrap">
        <div className="title">{blog.title}</div>
        <div className="blog-date">{moment(blog.date).format("DD MMMM YYYY")}</div>
        <div className="description">{createExcerpt(blog.body)}</div>
        {/* Using Link for a seamless experience */}
        <Link to={`/blog/${blog.id}`} className="read-btn-link">
          <div className="read-btn">
            Read More <img src="/assets/images/arrow-up-right.png" alt="Read More" />
          </div>
        </Link>
      </div>
    </div>
  );

  return (
    <div>
      <Helmet>
        <title>MPLOI - Bridging the gap between great employers and candidates with AI</title>
      </Helmet>
      <Header />
      <Banner />
      <Member />
      
      <div className="aboutSection4">
        <div className="blog-header">
          <div className="heading">From The Blog</div>
          <div className="all-btn">
            {/* <Link to="/blogs">View All</Link> */}
          </div>
        </div>
        <div>
          {isLoading && <p style={{textAlign: 'center', padding: '50px'}}>Loading our latest stories for you...</p>}
          {error && <p style={{textAlign: 'center', padding: '50px', color: 'red'}}>{error}</p>}
          {!isLoading && !error && (
            <>
              {/* --- Desktop Slider --- */}
              <div className="slider-container">
                {blogs.length > 0 ? (
                  <Slider {...settings}>
                    {blogs.map(blog => (
                      <div key={blog.id} className="slider-item-padding">
                        {renderBlogCard(blog)}
                      </div>
                    ))}
                  </Slider>
                ) : (
                  <p style={{textAlign: 'center', padding: '50px'}}>No blog posts have been written yet. Check back soon!</p>
                )}
              </div>

              {/* --- Mobile Card View --- */}
              <div className="blog-card-mob">
                {blogs.slice(0, 3).map(blog => (
                  <div key={blog.id} className="card-wrap-blog">
                    {renderBlogCard(blog)}
                  </div>
                ))}
              </div>
            </>
          )}
          <div className="all-btn-mob mt-5">
            <Link to="/blogs">View All</Link>
          </div>
        </div>
      </div>

      {/* <JobSearch
        description="Transform your job search with MPLOI's AI-powered matching. Say hello to seamless opportunities and goodbye to endless scrolling."
        showButtons
        title={<div className="title"><span>Candidate or Job Search </span><br /> All From Your MPLOI App</div>}
        subDescription={<div className="sub-description">Join Today and Find Your Perfect Fit!</div>}
        image={<img src="/assets/images/jobSearch.png" alt="For Jobs" className="img-fluid" />}
      /> */}
      <Footer />
    </div>
  );
}

export default About;